/**
 * StatisticsRawData_MenuOption
 * --
 */
import React from 'react';
import { Descriptions, Table, Button } from 'antd';
import { Content, Title, Row, Col, Statistic, TabMenu } from 'components';
import moment from 'moment';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import { downloadXlsx } from 'utils/XlsxDownloader';
/* 

결제수단별 매출 : 사용중인 필드
  payment_type: 결제수단
  totalAmount: 합계금액
  netSales: 순매출
  paymentsCount: 판매수량
  couponAppliedCount: 쿠폰사용수량
  discountAmount: 쿠폰사용금액
*/

/**----------------------------------------
 * [Component] 메뉴별 매출
 * ----------------------------------------
 */
const StatisticsRawData_MenuOption = ({
  headerData,
  data, // 차트 데이터
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const columns = [
    {
      title: '옵션명',
      dataIndex: 'option_title',
      width: 160,
      align: 'center',
    },
    {
      title: '옵션수량',
      dataIndex: 'quantity',
      width: 125,
      align: 'center',
    },
    {
      title: '하위항목',
      dataIndex: 'option_name',
      // width: 90,
      align: 'center',
    },
    {
      title: '하위항목수량',
      dataIndex: 'total_option_count',
      width: 125,
      align: 'center',
    },
    {
      title: '옵션금액',
      dataIndex: 'option_price',
      width: 125,
      align: 'center',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
    },
  ];
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // console.log('headerData: ', headerData);

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <div style={{ background: '#fff' }}>
          {headerData && (
            <Descriptions
              className="boxShadow"
              // title="User Info"
              size="small"
              // layout="vertical"
              // column={6}
              column={2}
              bordered
              style={{ width: '100%' }}
              labelStyle={{ width: '18%', fontWeight: 'bold' }}
              contentStyle={{ textAlign: 'right', width: '25%' }}
              items={[
                {
                  key: 'menu_name',
                  label: '메뉴명',
                  contentStyle: { textAlign: 'center' },
                  children: headerData.menu_name,
                },
                {
                  key: 'totalAmount',
                  label: '총매출',
                  children: (
                    <p>
                      {stringToMoneyFormat(Number(headerData.totalAmount) ?? 0)}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCount',
                  label: '주문건수',
                  children: (
                    <p>
                      {stringToMoneyFormat(Number(headerData.payments_count))}
                    </p>
                  ),
                },
                {
                  key: 'netsSales',
                  label: '순매출',
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        Number(headerData.totalAmount) ??
                          0 - headerData.discountAmount
                      )}
                    </p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        Number(headerData.discountAmount) ?? 0
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundAmount',
                  label: '환불금액',
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        Number(headerData.refundAmount) ?? 0
                      )}
                    </p>
                  ),
                },
              ]}
            />
          )}
        </div>
        <br />
        <Col x={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() =>
              downloadXlsx({
                columns: columns?.map((column) => {
                  if (column?.title === '쿠폰내역') {
                    column.dataIndex = 'coupon_info_detail';
                  }
                  return column;
                }),
                rows: data?.map((_item) => {
                  const { coupon_info, product_information } = _item;
                  return {
                    ..._item,
                    product_information: product_information
                      ?.map((menu) => {
                        return `메뉴명: ${menu?.menu_name}, 수량: ${
                          menu?.num
                        }, 금액: ${stringToMoneyFormat(
                          menu.price * menu.num
                        )}원`;
                      })
                      .join('\n'),
                    coupon_info: coupon_info?.length ?? 0,
                    coupon_info_detail: coupon_info
                      ?.map((coupon) => {
                        return `쿠폰명: ${
                          coupon?.coupon_name
                        }, 할인금: ${stringToMoneyFormat(
                          coupon?.discount_price
                        )}원`;
                      })
                      .join('\n'),
                  };
                }),
                fileName: '일자별_상세내역_리포트',
              })
            }
          >
            엑셀로 다운로드
          </Button>
        </Col>
        <br />

        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            // style={{ minWidth: 1500 }}
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            columns={columns}
            scroll={
              {
                // x: 1140,
              }
            }
            pagination={{ pageSize: 100 }}
            style={{ minHeight: 580 }}
          />
        </div>
      </Content>
    </>
  );
};

StatisticsRawData_MenuOption.defaultProps = {
  headerData: null,
};
export default StatisticsRawData_MenuOption;
